<template>
  <div class="asset-count-table-cell">
    <div class="status" v-if="vmCount">
      <router-link :to="{ name: 'account-hosts', query: { accountKey: accountKey, nickName: nickName } }">
        <a class="body3">{{ vmCount }} VMs</a>
      </router-link>
    </div>
    <div class="status" v-if="containerCount">
      <router-link :to="{ name: 'account-containers', query: { accountKey: accountKey, nickName: nickName } }">
        <a class="body3">{{ containerCount }} Containers</a>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssetCountTableCell',
  props: {
    vmCount: {
      type: [String, Number]
    },
    containerCount: {
      type: [String, Number]
    },
    accountKey: {
      type: [String, Number]
    },
    nickName: {
      type: [String, Number]
    }
  },
  data () {
    return {}
  },
  mounted () {},
  computed: {}
}
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/table/cell/AssetCountTableCell.vue